import {
    ALARMS_REPORT_REQUEST_GET,
    ALARMS_REPORT_RESPONSE_GET_SUCCESS,
    ALARMS_REPORT_RESPONSE_GET_FAIL,
	REPORTS_REQUEST_ADD,
	REPORTS_RESPONSE_ADD_FAIL,
	REPORTS_RESPONSE_ADD_SUCCESS,
	RESET_REPORTS_ADD,
	REPORT_DELETE_REQUEST,
	REPORT_DELETE_SUCCESS,
	REPORT_DELETE_FAIL,
	RESET_REPORT_DELETE,
	EDIT_ALARMS_REPORT_REQUEST_GET,
	EDIT_ALARMS_REPORT_RESPONSE_GET_SUCCESS,
	EDIT_ALARMS_REPORT_RESPONSE_GET_FAIL,
	KPI_ALARMS_REPORT_REQUEST_GET,
	KPI_ALARMS_REPORT_RESPONSE_GET_SUCCESS,
	KPI_ALARMS_REPORT_RESPONSE_GET_FAIL,
} from '../../constants/maintenance/alarmsReportConstants';
import { UI_STATES } from '../../constants/commonConstants';

export const alarmsReportListReducer = (state = { alarmsReport: {} }, action) => {
	switch (action.type) {
		case ALARMS_REPORT_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case ALARMS_REPORT_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				alarmsReport: action.payload,
			};
		case ALARMS_REPORT_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const alarmsReportListKpiReducer = (state = { alarmsReportKpi: {} }, action) => {
	switch (action.type) {
		case KPI_ALARMS_REPORT_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case KPI_ALARMS_REPORT_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				alarmsReportKpi: action.payload,
			};
		case KPI_ALARMS_REPORT_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const reportsAddReducer = (
	state = {
		successMessageOnAdd: null,
		addError: null,
		addData: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case REPORTS_REQUEST_ADD:
			return { ...state, loading: true, addError: null };
		case REPORTS_RESPONSE_ADD_FAIL:
			return {
				...state,
				loading: false,
				addError: action.payload,
			};
		case REPORTS_RESPONSE_ADD_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_REPORTS_ADD:
			return {
				...state,
				loading: false,
				successMessageOnAdd: null,
				addError: null,
				addData: [],
			};
		default:
			return state;
	}
};

export const deleteAlarmReportReducer = (
    state = { status: null, error: null, data: [] },
    action
) => {
    switch (action.type) {
        case REPORT_DELETE_REQUEST:
            return {
                ...state,
                status: UI_STATES.LOADING,
                error: null,
            };
        case REPORT_DELETE_SUCCESS:
            return {
                ...state,
                status: UI_STATES.SUCCESS,
                data: action.payload,
            };
        case REPORT_DELETE_FAIL:
            return {
                ...state,
                status: UI_STATES.FAILURE,
                error: action.payload,
            };
        case RESET_REPORT_DELETE:
            return {
                ...state,
                status: null,
                error: null,
                data: [],
            };
        default:
            return state;
    }
};

  export const alarmReportEditReducer = (state = { alarmsReportEdit: {} }, action) => {
	switch (action.type) {
		case EDIT_ALARMS_REPORT_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case EDIT_ALARMS_REPORT_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				alarmsReportEdit: action.payload,
			};
		case EDIT_ALARMS_REPORT_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};